import Swal from 'sweetalert2';

export default class SweetAlertUtil {

  static alertaAdvertencia(titulo: string, mensaj: string) {
    Swal.fire({
      icon: 'warning',
      title: titulo,
      text: mensaj,
      showConfirmButton: false,
    })
  }

  static alertaExito(titulo: string, mensaj: string) {
    Swal.fire({
      icon: 'success',
      title: titulo,
      text: mensaj,
      showConfirmButton: false,
      timer: 3000
    })
  }

  static alertaError(titulo: string, mensaj: string) {
    Swal.fire({
      icon: 'error',
      title: titulo,
      text: mensaj,
      showConfirmButton: false,
      timer: 3000
    })
  }

  static alertaAdvertenciaHtml(titulo: string, mensajeHtml: string) {
    Swal.fire({
      title: titulo,
      icon: 'warning',
      showConfirmButton: false,
      html: mensajeHtml
    });
  }

  static alertaExitoHtml(titulo: string, mensajeHtml: string) {
    Swal.fire({
      title: titulo,
      icon: 'success',
      showConfirmButton: false,
      html: mensajeHtml,
      timer: 10000
    });
  }

  static alertaAdvertenciaList(titulo: string, mensajeHtml: Array<string>) {
    const estructuraHtml = `
          <h2>Se presentaron las siguientes advertencias:</h2>
          <ul>
            ${mensajeHtml.map((error, index) => `<li key=${index}>${error}</li>`).join('')}
          </ul>
        `;
    Swal.fire({
      title: titulo,
      icon: 'warning',
      showConfirmButton: false,
      html: estructuraHtml
    });
  }

  static showLoading(titulo: string) {
    Swal.fire({
      title: titulo,
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      showCancelButton: false,
      preConfirm: () => { },
      showLoaderOnConfirm: true,
      didOpen: () => {
        Swal.showLoading();
      }
    });
  }

  static hideLoading() {
    Swal.close();
  }
}